import request, { requestV2 } from './utils';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const uploadFileApi = (file, onUploadProgress) => request({
    url: '/files/upload',
    method: 'POST',
    headers: {
        'content-type': 'multipart/form-data',
    },
    data: file,
    onUploadProgress,
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const updateFileApi = (item) => request({
    url: `/files/${item.id}`,
    method: 'PUT',
    data: item,
});
export const attachFilesApi = (items) => request({
    url: '/files/attach',
    method: 'POST',
    data: { items },
});
export const deleteFileLinkApi = ({ pivotId }) => request({
    url: `/files/${pivotId}`,
    method: 'DELETE',
});
export const getConfigApi = () => request({
    url: '/config',
    method: 'GET',
});
export const getSupportLanguagesApi = () => request({
    url: '/support-languages',
    method: 'GET',
});
export const getFavoritesApi = (modelType) => requestV2({
    url: `/favorites/${modelType}`,
    method: 'GET',
});
export const addToFavoriteApi = (modelType, id) => requestV2({
    url: `/favorites/${modelType}/${id}`,
    method: 'POST',
});
export const deleteFromFavoriteApi = (modelType, id) => requestV2({
    url: `/favorites/${modelType}/${id}`,
    method: 'DELETE',
});
